module.exports = __webpack_public_path__ + "static/media/x.223b7774.svg";